import { Navigate, useLocation } from 'react-router';
import { useOrgStore } from '@/stores/org-store';
import { readOrgParam, ORG_PARAM } from '@/utils/org-deep-link';
import { Loading } from '@/loading';

/**
 * Catches legacy URLs without `/o/:orgId` prefix and redirects to the
 * org-scoped equivalent. Uses `?org=` param if present, otherwise falls
 * back to the current org from the store.
 */
const OrgRedirect = () => {
  const location = useLocation();
  const { currentOrg, orgs } = useOrgStore();

  if (!currentOrg) {
    return <Loading />;
  }

  // Check for ?org= param in legacy shared links
  const deepLinkOrgId = readOrgParam(location.search);
  let targetOrgId = currentOrg.orgid;

  if (deepLinkOrgId) {
    const targetOrg = orgs.find((org) => org.orgid === deepLinkOrgId);
    if (targetOrg) {
      targetOrgId = targetOrg.orgid;
    }
  }

  // Strip the ?org= param from search since it's now in the path
  const params = new URLSearchParams(location.search);
  params.delete(ORG_PARAM);
  const search = params.toString() ? `?${params.toString()}` : '';

  return (
    <Navigate
      to={`/o/${targetOrgId}${location.pathname}${search}${location.hash}`}
      replace
    />
  );
};

export default OrgRedirect;
